import { createFileRoute } from "@tanstack/react-router";
import { UploadView } from "@/views";

export const Route = createFileRoute("/_dashboard/upload")({
  component: UploadPage,
});

function UploadPage() {
  return <UploadView />;
}
